import { render, staticRenderFns } from "./VNavItem.vue?vue&type=template&id=47ed4593&"
import script from "./VNavItem.vue?vue&type=script&lang=js&"
export * from "./VNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports